import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { WEB_ROUTES } from '@portal-contract';
import { buttonVariants } from '@/lib/macondo';
import { useI18n } from '@/i18n/I18nProvider';
import { PageHeading } from '@/components/PageHeading';

/** `/session-expired`: idle or absolute timeout. Explains why, offers sign in. */
export function SessionExpiredScreen() {
  const { t } = useI18n();
  return (
    <div className="mx-auto flex w-full max-w-[440px] flex-col items-start gap-400 pt-400" data-screen="SessionExpiredScreen">
      <Clock size={28} aria-hidden="true" className="text-typography-secondary" />
      <PageHeading>{t('expired.heading')}</PageHeading>
      <p className="text-body text-typography-secondary">{t('expired.body')}</p>
      <Link to={WEB_ROUTES.login} replace className={`${buttonVariants({ size: 'lg' })} text-callout-medium min-h-[48px]`}>
        {t('signedOut.again')}
      </Link>
    </div>
  );
}
